<br><br>
<!-- <br><br> -->

<div class="section d-flex flex-column align-items-center justify-content-center" style="width: 100%;">
    <div class="row" id="print" style="width: 100%;">
        <div class="section d-flex flex-column align-items-center page-break" *ngFor="let a of receivedData">
            <div class="singleCard">
                <div>
                    <img src="assets/img/mepma/idbanner.jpg" alt="" height="110px" width="100%">
                    <div style="position: relative;">
                        <canvas id="qr-code{{a.id}}"
                            style="position: absolute;top: -30px;right:5px;background: white;width: 47px"></canvas>
                    </div>
                    <div class="card-body" style="font-size: 13px;padding: 1px 0px !important;margin-top: 18px;">
                        <table style="width: 100%;">
                            <tr>
                                <td rowspan="7"
                                    style="text-align: center; padding: 5px; position: relative;vertical-align: top;">
                                    <img src="{{a.image}}" alt="" class="imgcss">
                                </td>
                                <td class="wid">Name:</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{
                                    a.user_name | uppercase| slice:0:45 }}{{ a.user_name.length > 45 ?
                                    '...' : '' }}</td>
                            </tr>

                            <tr>
                                <td class="wid">Aadhar ID</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ a.aadhaar_number }}</td>
                            </tr>
                            <tr>
                                <td class="wid">Mela Date</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ melaDetails?.mela_date | date:'dd-MM-yyyy' }}</td>
                            </tr>

                            <tr>
                                <td class="wid">Location</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ melaDetails?.district_name}}</td>
                            </tr>
                            <tr>
                                <td class="wid">District</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ melaDetails?.district_name}}</td>
                            </tr>


                            <!-- <tr>
                                <td class="wid" *ngIf="a.type_of_id_card == 'Duty-Pass'">Contractor</td>
                                <td class="wid" *ngIf="a.type_of_id_card != 'Duty-Pass'">Department</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ a.department | uppercase | slice:0:45 }}{{ a.department.length > 45
                                    ?
                                    '...' : '' }}</td>
                            </tr>
                            <tr>
                                <td class="wid" *ngIf="a.type_of_id_card == 'Duty-Pass'">Department</td>
                                <td class="wid" *ngIf="a.type_of_id_card != 'Duty-Pass'">Duty Point</td>
                                <td class="wid2">:</td>
                                <td class="wid3" *ngIf="a.type_of_id_card == 'Duty-Pass' "><span
                                        *ngIf="a.duty_point != 'null' ">{{a.duty_point |
                                        uppercase}}</span>
                                </td>
                                <td class="wid4" *ngIf="a.type_of_id_card != 'Duty-Pass' "><span
                                        *ngIf="a.duty_point != 'null' ">{{a.duty_point.length <
                                            57?a.duty_point:`${a.duty_point.slice(0,57)}...` | titlecase}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="wid">Shift Time</td>
                                <td class="wid2">:</td>
                                <td class="wid3"><span *ngIf="a.shift_time != 'null'">{{a.shift_time |
                                        uppercase}}</span>
                                </td>
                            </tr> -->
                            <!-- <tr
                                *ngIf="a.type_of_id_card == 'This Temple STAFF ON DUTY' || a.type_of_id_card == 'OFFICER ON DUTY' || a.two_wheeler == true">
                                <td colspan="3"
                                    style="color: red; font-size: 8px; font-style: italic;font-weight: 900;">TWO WHEELER
                                    ALLOWED
                                    DUTY POINT</td>
                            </tr> -->
                            <!-- <tr
                                *ngIf="a.type_of_id_card != 'This Temple STAFF ON DUTY' || a.type_of_id_card != 'OFFICER ON DUTY' || a.two_wheeler == false">
                                <td colspan="3" style="color: red; font-size: 8px; font-style: italic;">&nbsp;</td>
                            </tr> -->
                            <tr>
                                <td>
                                    <!-- <img src="assets/sdms_icons/eo.png" alt="" width="47px" height="25px"
                                        style="position: absolute;left: 64%; width: 137px;height: 46px;bottom: 28px;transform: rotate(-5deg)"> -->

                                    <!-- <span style="position: absolute;left: 75%;top: 88%;font-size: 8px;" *ngIf="a.department.length >= '24'">{{date}}</span> -->


                                    <!-- <span style="position: absolute;left: 75%;top: 85%;font-size: 8px;" *ngIf="a.department.length < 24">{{date}}</span> -->

                                </td>
                            </tr>
                        </table>
                        <br>
                        <table style="width: 100%;position: absolute;bottom: 0px;">
                            <tr *ngIf="a.type_of_id_card == 'This Temple STAFF ON DUTY' || a.type_of_id_card == 'OFFICER ON DUTY'"
                                style="display: flex;text-align: center;justify-content: space-between;margin-top: -10px;">
                            <tr *ngIf="a.type_of_id_card != 'This Temple STAFF ON DUTY' || a.type_of_id_card != 'OFFICER ON DUTY'"
                                style="display: flex;text-align: center;justify-content: space-between;position: relative;">

                                <td style="font-size: 8px;"> <b>Signature of the Officer</b><br>
                                    <i>(To be signed after verification.)</i>
                                </td>
                                <span style="position: absolute;right: 10px;;font-size: 8px;">{{date}}</span>
                                <!-- <img src="assets/sdms_icons/eo.png" alt=""
                                    style="position: absolute;right: 10px;bottom: 7px; width: 127px;height: 40px;transform: rotate(-5deg)"> -->

                            </tr>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="button-container" style="display: flex; justify-content: center;gap: 20px;margin-top: 20px;">
        <button class="btn btn-primary" (click)="printContent()">Print</button>
        <button class="btn btn-primary" (click)="Back()">Back</button>
    </div>
</div>

<!-- CSS -->
<style>
    @media print {
        @page {
            size: A4 portrait;
            margin: 0;
            padding: 0;
        }

        #print {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }


        .card-body {
            font-size: 8px;
        }

        .page-break {
            break-before: always;
            page-break-before: always;
        }

        .print-six:nth-child(6n + 1) {
            break-before: always;
            page-break-before: always;

        }

        .button-container {
            display: none !important;
        }
    }

    .ellipsis-text {
        white-space: nowrap;
        /* Prevent text from wrapping */
        overflow: hidden;
        /* Hide overflowing text */
        text-overflow: ellipsis;
        /* Show "..." when text overflows */
        width: 200px;
        /* Set a fixed width */
    }

    #print {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .card {
        min-width: 10.4cm !important;
        max-width: 10.4cm !important;
        /* Set width for display */
        min-height: 8.8cm !important;
        max-height: 8.8cm !important;
        /* Set height for display */
        box-sizing: border-box;
        margin-bottom: 20px;
        /* Space between cards */
    }

    .singleCard {
        min-width: 10.0cm !important;
        max-width: 10.0cm !important;
        min-height: 7.8cm !important;
        max-height: 7.8cm !important;
        box-sizing: border-box;
        border: solid 1px grey;
        position: relative;
    }

    .d-flex {
        display: flex;
    }

    thead,
    tbody,
    tfoot,
    tr,
    td,
    th {
        margin-top: -10px !important;
        padding: 0px 2px;
    }

    .justify-content-between {
        justify-content: space-between;
    }

    .wid {
        /* width: 25%; */
        font-size: 12.5px;
        color: #000;
    }

    .widt {
        /* width: 25%; */
        font-size: 10px;
    }

    .wid2 {
        width: 20px;

    }

    .wid3 {
        width: 48%;
        border-bottom: 1px solid;
        border-bottom-style: dashed;
        font-size: 11px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 50px;


    }

    .wid4 {
        width: 48%;
        border-bottom: 1px solid;
        border-bottom-style: dashed;
        font-size: 10px;
        line-height: 10px;
        font-weight: bold;
        overflow: hidden;
        max-width: 50px;
        max-height: 20px;



    }

    .imgee {
        filter: brightness(0.5);
        /* Decrease brightness by 50% */
    }

    .print-six:nth-child(6n + 1) {
        break-before: always;

        page-break-before: always;

    }

    .no-break {
        break-inside: avoid;
        page-break-inside: avoid;
    }
</style>


<style>
    /* Container for the content */
    .content {
        position: relative;
        padding: 50px;
        background-color: #f9f9f9;
        min-height: 400px;
        border: 1px solid #ddd;
    }

    /* Watermark styling */
    .watermark {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 4em;
        color: rgba(0, 0, 0, 0.1);
        /* Light grey with transparency */
        pointer-events: none;
        /* Prevent interaction */
        z-index: 0;
        white-space: nowrap;
    }
</style>